<div class="main-root">
    <router-outlet></router-outlet>
</div>
<app-toast></app-toast>
<div class="loading" [ngClass]="{'d-none':!loading}">
    <div class="loading-item">
        <div class="hm-spinner"></div>
    </div>
</div>